import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineFileCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={15}
    fill="none"
    viewBox="0 0 13 15"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m3.8 9.05 1.575 1.05 3.15-4.2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M12.2 13.25a1.05 1.05 0 0 1-1.05 1.05H1.7a1.05 1.05 0 0 1-1.05-1.05V1.7A1.05 1.05 0 0 1 1.7.65h6.825L12.2 4.325z"
    />
  </svg>
);
export default SvgStreamlineFileCheck;
